import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useContext } from 'react';
import UsersContext from './UsersContext';

export default function FormDialog() {
  const context  = useContext(UsersContext);

  return (
    <div>

      <Dialog open={context.shouldShowDeleteUserDialog}>
        <DialogTitle >Confirmation</DialogTitle>
        <DialogContent>
        Are your sure you want to delete this user?
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>context.hideDeleteUserDialog()} color="primary">
            No
          </Button>
          <Button 
            onClick={()=> {
              context.deleteUser(context.users.selectedUser);
              context.hideDeleteUserDialog();
          }} 
          color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}